module.exports = __webpack_public_path__ + "img/229.eff07c9e.jpg";